import { PlayIcon, UserPlusIcon, ClipboardDocumentListIcon } from '@heroicons/react/24/outline';
import { AppEventDetail } from '../../types/event';
import Button from '../ui/Button';
import AddToCalendarButton from './AddToCalendarButton';

interface EventActionsProps {
  event: AppEventDetail;
}

function hasEnded(event: AppEventDetail): boolean {
  const end = event.endAt ? new Date(event.endAt) : new Date(event.startAt);
  return end.getTime() <= Date.now();
}

export default function EventActions({ event }: EventActionsProps) {
  const ended = hasEnded(event);

  return (
    <aside aria-label="Event actions" className="mb-8 lg:mb-0 lg:sticky lg:top-32">
      <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-3">
        Actions
      </p>
      <div className="flex flex-col gap-2">
        <AddToCalendarButton
          event={{
            title: event.title,
            startDate: new Date(event.startAt),
            endDate: event.endAt ? new Date(event.endAt) : null,
            isAllDay: event.allDay,
            location: event.venue || undefined,
            url: event.websiteUrl || undefined,
          }}
          variant="sidebar"
        />
        {event.recordingUrl && (
          <a
            href={event.recordingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center w-full h-12 px-3 text-sm font-medium whitespace-nowrap rounded-md border-2 border-primary text-primary hover:bg-primary hover:text-white focus-ring"
          >
            <PlayIcon className="h-5 w-5 mr-2 shrink-0" aria-hidden />
            Watch recording
          </a>
        )}
        {!ended && (
          <Button type="button" variant="secondary" className="w-full h-12 text-sm px-3 whitespace-nowrap">
            <UserPlusIcon className="h-5 w-5 mr-2 shrink-0" aria-hidden />
            Register
          </Button>
        )}
        <Button type="button" variant="secondary" className="w-full h-12 text-sm px-3 whitespace-nowrap">
          <ClipboardDocumentListIcon className="h-5 w-5 mr-2 shrink-0" aria-hidden />
          Evaluation survey
        </Button>
      </div>
    </aside>
  );
}
